module.exports = __webpack_public_path__ + "static/fonts/iconfont.aa3d760f.ttf";